import React from "react";
import Logo from "../assets/images/Logo.png";
import { Link } from "react-router-dom";

const SignUp = () => {
  return (
    <div className="bg-arena-background h-full">
      <div className="flex justify-center">
        <div className="bg-white w-[448px] p-8">
          <div className="flex items-center justify-center">
            <img src={Logo} alt="logo" className="w-[92px] h-[92px]" />
          </div>
          <h1 className="mt-10 text-navy-blue text-[25px] font-semibold text-center border-b pb-20">
            Sign Up
          </h1>
          <div className="flex flex-col mt-4">
            <form>
              <div className="flex flex-col">
                <label htmlFor="business-name">Business Name</label>
                <input
                  type="text"
                  id="business-name"
                  placeholder="Omoke Ent"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>
              <div className="flex flex-col mt-2">
                <label htmlFor="phone-no">Phone Number</label>
                <input
                  type="text"
                  id="phone-no"
                  placeholder="08033045559"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>
              <div className="flex flex-col mt-2">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  placeholder="example@gmail.com"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>
              <div className="flex flex-col mt-2 relative">
                <label htmlFor="password">Password</label>
                <svg
                  className="absolute right-4 top-14"
                  width="13"
                  height="11"
                  viewBox="0 0 13 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.5">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.07225 7.60439C5.47815 7.87832 5.97285 8.04395 6.49926 8.04395C7.89456 8.04395 9.02983 6.90365 9.02983 5.50218C9.02983 4.97344 8.86493 4.47655 8.59221 4.06885L7.9009 4.76322C8.01506 4.97981 8.07848 5.23462 8.07848 5.50218C8.07848 6.37491 7.36815 7.08839 6.49926 7.08839C6.23288 7.08839 5.97919 7.02469 5.76355 6.91002L5.07225 7.60439ZM10.6787 1.97322C11.5984 2.8141 12.3785 3.94802 12.962 5.31128C13.0127 5.43232 13.0127 5.57246 12.962 5.68713C11.6047 8.85956 9.18829 10.7579 6.49917 10.7579H6.49283C5.26877 10.7579 4.09545 10.3566 3.06165 9.62401L1.83125 10.8599C1.73612 10.9554 1.61562 11 1.49511 11C1.37461 11 1.24776 10.9554 1.15897 10.8599C1.00041 10.7006 0.975045 10.4458 1.10189 10.261L1.12092 10.2356L10.5011 0.813812L10.5012 0.813807C10.5138 0.801068 10.5265 0.788329 10.5329 0.77559L10.5329 0.775584C10.5455 0.762845 10.5582 0.750107 10.5646 0.737368L11.1607 0.138555C11.351 -0.046185 11.6491 -0.046185 11.833 0.138555C12.0233 0.323295 12.0233 0.629072 11.833 0.813812L10.6787 1.97322ZM3.96392 5.50482C3.96392 5.67045 3.98295 5.83608 4.00832 5.98897L1.66168 8.34599C1.02745 7.60703 0.475671 6.71519 0.0380537 5.68956C-0.0126846 5.57489 -0.0126846 5.43475 0.0380537 5.31371C1.3953 2.14128 3.81171 0.249282 6.49449 0.249282H6.50083C7.40778 0.249282 8.28936 0.465874 9.10117 0.873576L6.98285 3.00127C6.83063 2.97579 6.66573 2.95668 6.50083 2.95668C5.09919 2.95668 3.96392 4.09697 3.96392 5.50482Z"
                      fill="#030229"
                    />
                  </g>
                </svg>

                <input
                  type="password"
                  id="password"
                  placeholder="....."
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>
              <div className="flex items-center gap-2">
                <input type="checkbox" className="w-[15px] h-[15px]" />
                <p className="w-[322px] text-base font-normal text-navy-blue mt-5">
                  By creating an account you agree to the{" "}
                  <span className="underline text-text-orange">
                    terms of use
                  </span>{" "}
                  and our{" "}
                  <span className="underline text-text-orange">
                    privacy policy
                  </span>
                  .
                </p>
              </div>
              <div className="mt-6">
                <button className="w-[380px] h-[50px] bg-text-orange text-white text-base font-semibold rounded-md">
                  Create Account
                </button>
              </div>
            </form>
          </div>
          <p className="mt-4 text-center">
            Already have an account?{" "}
            <span>
              <Link className="text-text-orange" to="/login">
                Log in
              </Link>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
